import React from "react";
import { useNavigate } from "react-router-dom";
import {
  AccountBalanceWallet as TaxIcon,
  ArrowForward as ArrowForwardIcon,
  Category as CategoryIcon,
  Inventory2 as InventoryIcon,
  Inventory as ProductsIcon,
} from "@mui/icons-material";
import { Box, Button, Card, CardActionArea, CardContent, Typography } from "@mui/material";

const modules = [
  {
    title: "Group of Product/Service",
    description: "Create groups and default units for bills, purchases and catalog items.",
    path: "/locsy/products/groups",
    icon: <CategoryIcon sx={{ fontSize: 52 }} />,
    colors: ["#e0edff", "#eff6ff"],
  },
  {
    title: "Products / Services",
    description: "Shared catalog with React dashboard and Vyapar. Add, import and manage items.",
    path: "/locsy/products/catalog",
    icon: <ProductsIcon sx={{ fontSize: 52 }} />,
    colors: ["#ffead0", "#fff7ed"],
  },
  {
    title: "Inventory / Stock",
    description: "Track stock, low-stock and out-of-stock products in the same billing catalog.",
    path: "/locsy/products/inventory",
    icon: <InventoryIcon sx={{ fontSize: 52 }} />,
    colors: ["#dbeafe", "#f0f9ff"],
  },
  {
    title: "Set taxes",
    description: "Configure service charge and other bill taxes with your own percentage.",
    path: "/locsy/products/taxes",
    icon: <TaxIcon sx={{ fontSize: 52 }} />,
    colors: ["#d9f99d", "#f7fee7"],
  },
];

export default function ProductsHub() {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxWidth: 1180, mx: "auto", pb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight={800} sx={{ fontSize: { xs: "1.6rem", sm: "2rem" } }}>Products</Typography>
        <Typography color="text.secondary">Manage the same products, stock and billing settings used in Loksy Vyapar.</Typography>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 2 }}>
        {modules.map((module) => (
          <Card key={module.path} elevation={0} sx={{ borderRadius: 3, overflow: "hidden", border: "1px solid", borderColor: "divider", height: "100%" }}>
            <CardActionArea onClick={() => navigate(module.path)} sx={{ height: "100%", alignItems: "stretch" }}>
              <Box sx={{ minHeight: 135, display: "grid", placeItems: "center", color: "primary.dark", background: `linear-gradient(135deg, ${module.colors[0]}, ${module.colors[1]})` }}>{module.icon}</Box>
              <CardContent sx={{ p: 2 }}>
                <Typography fontWeight={800}>{module.title}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, minHeight: 60 }}>{module.description}</Typography>
                <Button size="small" endIcon={<ArrowForwardIcon />} sx={{ mt: 1, px: 0, textTransform: "none" }}>Open</Button>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
      <Box sx={{ mt: 3, p: 2, borderRadius: 2, bgcolor: "primary.50", border: "1px solid", borderColor: "primary.light" }}>
        <Typography fontWeight={700}>Catalog import & export</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>Products / Services has the same default-catalog import used by Vyapar. Shops granted “Export Catalog” access by an admin can share their selected catalog back to the category template.</Typography>
        <Button variant="contained" sx={{ mt: 1.5, textTransform: "none" }} onClick={() => navigate("/locsy/products/catalog")}>Manage catalog</Button>
      </Box>
    </Box>
  );
}
